import { useEffect, useState } from "react";

import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import LoadingWheel from "../../components/shared/LoadingWheel";
import { usePageNameContext } from "../../contexts/PageTitleContext";

import { ILead, LeadDocumentFilter, LeadStatus } from "../../models/Lead";
import VehiclesCollectedTable from "../../components/vehiclesCollected/VehiclesCollectedTable";
import CustomDatePicker from "../../components/awaitingInventory/CustomDatePicker";
import { DateRangeType } from "react-tailwindcss-datepicker";

export default function VehiclesCollected() {
  const { setInfo } = usePageNameContext();
  const [leads, setLeads] = useState<ILead[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [hideAwaitingCod, setHideAwaitingCod] = useState(false);
  const [showCompleted, setShowCompleted] = useState(false);
  const [showDropOff, setShowDropOff] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const [dates, setDates] = useState<DateRangeType>({
    startDate: null,
    endDate: null
  });


  // const { leadsWithFilters } = useLeadsWithFilters({ 
  //   query: refreshTriggers[0] as string, 
  //   pageFilter: 3, 
  //   awaitingCod: !hideAwaitingCod, 
  //   includeCompleted: showCompleted, 
  //   startDate: dates.startDate ? new Date(dates.startDate) : null, 
  //   endDate: dates.endDate ? new Date(dates.endDate) : null 
  // });

  const handleDatesChange = (newDates: DateRangeType) => {
    setDates(newDates);
  };

  useEffect(() => {
    setInfo({
      name: "Vehicles Collected",
      desc: "View and manage your collected and not-yet-completed leads here",
    });
  }, []);

  return (
    <>
      <div className="mt-2 flex justify-between">
        <div className="flex gap-x-5">
          {/* <div className="relative flex items-stretch flex-grow focus-within:z-10">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </div>
            <input
              type="text"
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 sm:text-sm w-72"
              placeholder="Search Name, VRM or Postcode"
            />
          </div> */}

          <div className="flex items-center">
            <input id="hideAwaitingCod" onChange={(e) => setHideAwaitingCod(e.target.checked)} value="hideAwaitingCod" checked={hideAwaitingCod} type="checkbox" className="mr-2 h-5 w-5" />
            <label htmlFor="hideAwaitingCod">Hide Awaiting COD</label>
          </div>

          <div className="flex items-center">
            <input id="showCompleted" onChange={(e) => setShowCompleted(e.target.checked)} value="showCompleted" checked={showCompleted} type="checkbox" className="mr-2 h-5 w-5" />
            <label htmlFor="showCompleted">Show Completed Leads</label>
          </div>

          <div className="flex items-center">
            <input id="showDropOff" onChange={(e) => setShowDropOff(e.target.checked)} value="showDropOff" checked={showDropOff} type="checkbox" className="mr-2 h-5 w-5" />
            <label htmlFor="showDropOff">Show Drop Off Leads</label>
          </div>

        </div>
        <div className="flex items-center">

        </div>
      </div>
      {showCompleted && (
        <div className="mt-2 flex justify-between">
          <CustomDatePicker dates={dates} handleDatesChange={handleDatesChange} />
        </div>
      )}

      <VehiclesCollectedTable
        additionalBody={{
          status: [
            LeadStatus.Collected,
            LeadStatus["Awaiting Payment"],
            ...(!hideAwaitingCod ? [LeadStatus["Awaiting COD"]] : []),
            ...(showCompleted ? [LeadStatus.Completed] : [])
            // ...(showDropOff ? [LeadStatus.Completed])
          ],
          completedOn: dates.startDate || dates.endDate ? {
            fieldName: "CompletedOn",
            start: dates.startDate ? new Date(dates.startDate) : null,
            end: dates.endDate ? new Date(dates.endDate) : null
          } : null,
          documentFilter: LeadDocumentFilter.All,
          vehicle: {
            isDropOff: showDropOff
          }
        }}
      />

    </>
  );
}
